import lazySizes from "lazysizes";
import sal from "sal.js";
import { header } from "./components/header";
import { toggleView } from "./components/toggleView";
import { collapsibleSection } from "./components/collapsible-section";

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;

function checkIfTouchDevice() {
  return (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  );
}

function swupReload() {
  document.body.setAttribute("data-menu-open", "false");
  document.body.setAttribute("data-overlay-open", "false");
  document.body.classList.remove("no-scroll");

  isNavToggled = false;

  sal({
    threshold: 0.01,
    once: true,
  });

  // nav(isNavToggled);
  toggleView();
  collapsibleSection();
  header();
}

function init() {
  sal({
    threshold: 0.01,
    once: true,
  });

  if (history.scrollRestoration) history.scrollRestoration = "manual";

  // nav(isNavToggled);
  toggleView();
  collapsibleSection();
  header();
}

function setupPlugins() {
  const swup = new Swup({
    animationSelector: '[class*="transition-"]',
    containers: ["#swup", "#swup-header", "#swup-footer"],
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupScrollPlugin({
        doScrollingRightAway: false,
        animateScroll: false,
        scrollFriction: 0,
        scrollAcceleration: 0,
      }),
    ],
  });

  swup.on("contentReplaced", () => {
    checks();
    swupReload();
  });
}

function checks() {
  isTouchDevice = checkIfTouchDevice();
  if (isTouchDevice) {
    document.documentElement.classList.add("is-touch");
  }
  isHomepage = document.body.classList.contains("page-home");
}

const elementsToCheckSticky = document.querySelectorAll(
  ".js-element-to-check-sticky"
);

const observer = new IntersectionObserver(
  ([entry]) => {
    entry.target.classList.toggle("is-sticky", entry.intersectionRatio < 1);
  },
  { threshold: [1.0] }
);

// Observe each element individually
elementsToCheckSticky.forEach((element) => observer.observe(element));

checks();
init();
